export default "__VITE_ASSET__B3Z_BZBB__"